<template>
  <div>
    <div class="pg-cab">
      <div class="col">
        <span class="tag">A empresa</span>
        <h1>Flor de Goiás Transportadora</h1>
      </div>
    </div>

    <section class="sec">
      <div class="col grade">
        <div>
          <h2 class="sec-h2">Uma operação, não uma plataforma</h2>
          <p class="sec-p tx">
            A Flor de Goiás opera desde {{ OPERACAO.desde }} a partir de {{ OPERACAO.base }},
            transportando carga na {{ OPERACAO.areaAtuacao }}. O trabalho é coordenar a carga
            do embarque até a entrega: receber o pedido, fechar valor e prazo, atribuir o
            veículo certo e responder pela mercadoria no caminho.
          </p>
          <p class="sec-p tx">
            A atividade registrada da empresa é o transporte de produtos perigosos — embarque
            que exige motorista habilitado, veículo compatível e documentação específica, e que
            boa parte das transportadoras não aceita. Isso é um diferencial da operação, não o
            seu limite: carga comum, fracionada ou dedicada, é atendida do mesmo jeito. O objeto
            social inclui ainda serviços de apoio administrativo, que sustentam a parte
            documental dos embarques.
          </p>
          <p class="sec-p tx">
            A capacidade vem de uma rede de motoristas parceiros e veículos agregados, selecionados
            e coordenados diretamente por nós. É o que permite absorver aumento de volume sem
            repassar ao cliente o custo de uma frota parada — e sem terceirizar a responsabilidade.
          </p>
          <p class="sec-p tx">
            Somos uma operação pequena, e isso é intencional: quem contrata fala com quem coordena,
            e a decisão sobre a sua carga não passa por três níveis de atendimento.
          </p>
        </div>

        <div class="painel-lado">
          <div class="painel-h">
            <b class="painel-t">Dados cadastrais</b>
            <b class="painel-t">{{ OPERACAO.desde }}</b>
          </div>
          <div class="dado-l"><span class="k">Razão social</span><span class="v ativ">{{ EMPRESA.razao }}</span></div>
          <div class="dado-l"><span class="k">CNPJ</span><span class="v">{{ EMPRESA.cnpj }}</span></div>
          <div class="dado-l"><span class="k">Fundação</span><span class="v">{{ EMPRESA.fundacao }}</span></div>
          <div class="dado-l"><span class="k">Situação cadastral</span><span class="v forte">{{ EMPRESA.situacao }}</span></div>
          <div class="dado-l"><span class="k">Natureza jurídica</span><span class="v ativ">{{ EMPRESA.natureza }}</span></div>
          <div class="dado-l"><span class="k">Atividade principal</span><span class="v ativ">{{ EMPRESA.cnaeCodigo }} — {{ EMPRESA.cnae }}</span></div>
          <div class="dado-l"><span class="k">Endereço</span><span class="v ativ">{{ EMPRESA.endereco }} — {{ EMPRESA.bairro }}</span></div>
          <div class="dado-l"><span class="k">Município</span><span class="v">{{ EMPRESA.cidade }} — {{ EMPRESA.cep }}</span></div>
          <div class="dado-l"><span class="k">Atendimento</span><span class="v forte">{{ EMPRESA.horario }}</span></div>
          <p class="aviso">{{ RESTRICOES }}</p>
        </div>
      </div>
    </section>

    <CompromissosSecao />
    <CtaSection />
  </div>
</template>

<script setup>
import CompromissosSecao from '@/components/CompromissosSecao.vue'
import CtaSection from '@/components/CtaSection.vue'
import { EMPRESA } from '@/config/contato'
import { OPERACAO, RESTRICOES } from '@/config/operacao'
</script>

<style scoped>
.cabeca { border-bottom: 1px solid var(--fio); padding: 128px 0 40px; background: var(--nevoa); }
.cabeca h1 {
  font-family: 'Archivo', sans-serif;
  font-weight: 900;
  font-size: clamp(32px, 4vw, 54px);
  letter-spacing: -.045em;
  line-height: 1;
  margin-top: 12px;
}
.grade { display: grid; grid-template-columns: 1.3fr 1fr; gap: 56px; align-items: start; }
.tx { max-width: 540px; margin-top: 14px; }
.ficha { border: 1px solid var(--fio); border-radius: var(--r); box-shadow: var(--sombra); background: var(--papel-2); padding: 22px 24px 24px; }
.ficha-l .v.ativ { font-size: 12px; line-height: 1.45; max-width: 220px; }

@media (max-width: 900px) {
  .grade { grid-template-columns: 1fr; gap: 34px; }
  .tx { max-width: none; }
  .ficha-l .v.ativ { max-width: 60%; }
}
</style>
